import axios from 'axios';
import { baseUrl } from '@/config';

const updateEntities = ({ commit }, payload) => {
  commit("updateEntitiesList", payload);
};

const fetchEntities = ({ commit }) => {
  console.log('triggered');
  axios.get(baseUrl + '/getEntityList')
    .then(resp => {
      commit("updateEntitiesList", resp.data);
    })
    .catch(err => {
      console.log(err);
      console.log(err.message);
    });
};


export default {
  updateEntities,
  fetchEntities,
};
